import {BaseConfig} from "../../infrastructure/config/base-config";
import {CompetitorPlayersStatsModuleTerms} from "./competitor-players-stats-module.terms";

export class CompetitorPlayersStatsModuleConfig extends BaseConfig {
  static injectables = [CompetitorPlayersStatsModuleTerms];

  constructor(terms: CompetitorPlayersStatsModuleTerms){
    super('CompetitorPlayersStats', null, terms);
  }
}
